module.exports = __webpack_public_path__ + "img/marker.ef7695c0.png";